module.exports = __webpack_public_path__ + "static/media/kamila.42daa035.ogg";